import { string } from 'yup'

export const dateStringSchema = string()
	.checkStringDate({ message: 'Неверная дата', format: 'DD.MM.YYYY' })
	.required()
